import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { Wrapper, Background, Padder} from 'components'

import Header from './Header'
import Footer from './Footer'
import { useMouse } from '../../customHooks'

import * as S from './styles'
import theme from "../../style/theme";

const Layout = ({ children, pageContext,  hasTitle = true, hasHeader = true, hasFooter = true, hasMagicMouse = true, inverted  }) => {
  const { translations, currentRoute, siteMetadata } = pageContext
  const { routes, footer, lang } = translations
  const mouseStatus = useMouse()



  const {
    metaTitle,
    metaDescription,
    metaAuthor,
    metaMeta = []
  } = currentRoute



  const contactUsSlug = routes.find(route => route.template === "contact").slug

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: siteMetadata.lang,
        }}
        title={siteMetadata.title}
        titleTemplate={`%s | ${metaTitle}`}
        meta={[
          {
            name: `viewport`,
            content: "width=device-width,minimum-scale=1,initial-scale=1",
          },
          {
            name: `google`,
            content: "notranslate",
          },
          {
            property: `title`,
            content: metaTitle,
          },
          {
            name: `description`,
            content: metaDescription,
          },
          {
            property: `og:title`,
            content: metaTitle,
          },
          {
            property: `og:description`,
            content: metaDescription,
          },
          {
            property: `og:type`,
            content: `website`,
          },
          {
            name: `twitter:card`,
            content: `summary`,
          },
          {
            name: `twitter:creator`,
            content: metaAuthor,
          },
          {
            name: `twitter:title`,
            content: metaTitle,
          },
          {
            name: `twitter:description`,
            content: metaDescription,
          },
        ].concat(metaMeta || [])}
      >
        <script id="Cookiebot" src="https://consent.cookiebot.com/uc.js" data-cbid="51c64436-14a7-4f72-af24-e0fcd53c745f" data-blockingmode="auto" type="text/javascript"></script>
        <link defer async href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,500&display=swap" rel="stylesheet" />
        <link defer async rel="stylesheet" type="text/css" charset="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
        <link defer async rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
      </Helmet>

      <S.Main hasTitle={hasTitle}>
        {currentRoute.label && hasTitle && <Wrapper size="large"><S.Title>{currentRoute.label}</S.Title></Wrapper>}
        {children}
      </S.Main>
    
      { hasHeader && <Header routes={routes} lang={lang} pathPrefix={siteMetadata.pathPrefix} inverted={inverted ? true : false} />}
          
      
      {hasFooter && <>
        <Background color={theme.colors.thirdary}>
          <Wrapper size="large">
            <S.FooterWrapper>
              <Padder size="regular">
                <Footer
                  {...footer}
                  pathPrefix={siteMetadata.pathPrefix}
                  contactUsSlug={(contactUsSlug && contactUsSlug !== currentRoute.slug) ? contactUsSlug : null}
                />
              </Padder>
            </S.FooterWrapper>
          </Wrapper>
        </Background>
        <Background color={theme.colors.blue.thirdary}>
          <S.FooterBottom>
            {footer.footerBottomText}
          </S.FooterBottom>
        </Background>
        </>
      }

      {hasMagicMouse && <S.MagicMouseWrapper>
        <S.MagicMouse  {...mouseStatus} />
      </S.MagicMouseWrapper>}
    </>
  )
}


Layout.propTypes = {
  pageContext: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  hasTitle: PropTypes.bool,
  hasHeader: PropTypes.bool,
  hasFooter: PropTypes.bool,
  hasMagicMouse: PropTypes.bool,
  inverted: PropTypes.bool
}

export default Layout